import { Injectable } from '@angular/core';
import { OfferType, ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Store } from '@ngrx/store';
import * as fromOfferReducers from '@view-offers/store/reducers';
import * as fromGA from '../store/actions';

@Injectable({
  providedIn: 'root',
})
export class GaEventService {
  constructor(public store: Store<fromOfferReducers.ViewOffersState>) {}

  OffersPageLoad() {
    this.store.dispatch(fromGA.OfferPageLoad());
  }

  OffersShowMoreClick(payload: OfferType) {
    this.store.dispatch(fromGA.OfferShowMoreClick({ payload }));
  }

  OffersComparisonClick(payload: ReplacementOffer) {
    this.store.dispatch(fromGA.OfferComparisonClick({ payload }));
  }

  OffersCompareModelsClick() {
    this.store.dispatch(fromGA.OfferCompareModelsClick());
  }

  OffersCompareNowClick() {
    this.store.dispatch(fromGA.OfferCompareNowClick());
  }

  OfferSpecDifferencesClick() {
    this.store.dispatch(fromGA.OfferSpecDifferencesClick());
  }

  AdditionalServicesPageLoad() {
    this.store.dispatch(fromGA.AdditionalServicesPageLoad());
  }

  AdditionalServicesPopUpClose(payload) {
    this.store.dispatch(fromGA.AdditionalServicesPopUpClose(payload));
  }

  AdditionalServicesPopUpShow() {
    this.store.dispatch(fromGA.AdditionalServicesPopUpShow());
  }

  AdditionalServicesContinueClick() {
    this.store.dispatch(fromGA.AdditionalServicesContinueClick());
  }

  ProductDetailsPageLoad() {
    this.store.dispatch(fromGA.ProductDetailsPageLoad());
  }

  ProductDetailsContinueClick() {
    this.store.dispatch(fromGA.ProductDetailsContinueClick());
  }

  ProductDetailsThumbnailClick() {
    this.store.dispatch(fromGA.ProductDetailsThumbnailClick());
  }

  CompleteOrderLoadDeliveryStep() {
    this.store.dispatch(fromGA.CompleteOrderLoadDeliveryStep());
  }

  CompleteOrderLoadDirectDebitStep() {
    this.store.dispatch(fromGA.CompleteOrderLoadDirectDebitStep());
  }

  CompleteOrderLoadPaymentStep() {
    this.store.dispatch(fromGA.CompleteOrderLoadPaymentStep());
  }

  ConfirmationPageLoad() {
    this.store.dispatch(fromGA.ConfirmationPageLoad());
  }

  DeliveryUnavailableModal() {
    this.store.dispatch(fromGA.DeliveryUnavailableModal());
  }

  DeliveryApiErrorModal() {
    this.store.dispatch(fromGA.DeliveryApiErrorModal());
  }

  AdditionalServicesRejectNewPolicy() {
    this.store.dispatch(fromGA.AdditionalServicesRejectNewPolicy());
  }

  AdditionalServicesToggleBenefits(payload) {
    this.store.dispatch(fromGA.AdditionalServicesToggleBenefits({ payload }));
  }

  AdditionalServicesProtectionSelect() {
    this.store.dispatch(fromGA.AdditionalServicesProtectionSelect());
  }

  AdditionalServicesExtraSelect(payload) {
    this.store.dispatch(fromGA.AdditionalServicesExtraSelect(payload));
  }
}
